import { configureStore } from "@reduxjs/toolkit";
import userDetailsReducer from '../features/user/userDetailsSlice'
import tokenReducer from '../features/token/tokenSlice'
import userPrincipalReducer from '../features/user/userPrincipalSlice'
import themeReducer from '../features/theme/themeSlice'

export const store = configureStore ({
    reducer: {
        userPrincipal: userPrincipalReducer,
        token: tokenReducer,
        userDetails: userDetailsReducer,
        theme: themeReducer
    }
})